/**
 * tg-salon-hero.js — Salon Hero carousel
 *
 * Initialises every .tg-sh__carousel on the page using class-based
 * DOM queries (no section.id IDs required). Preserves all logic from
 * the original inline script: arrow navigation, dot nav, touch swipe.
 */
(function () {
  'use strict';

  function initCarousel(carousel) {
    var slides  = carousel.querySelector('.tg-sh__slides');
    var prevBtn = carousel.querySelector('.tg-sh__arrow--prev');
    var nextBtn = carousel.querySelector('.tg-sh__arrow--next');
    var dotsWrap = carousel.querySelector('.tg-sh__dots');

    if (!slides) return;

    var total   = slides.children.length;
    var current = 0;

    if (total <= 1) return;

    var dots = dotsWrap
      ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.tg-sh__dot'))
      : [];

    function goTo(index) {
      current = (index + total) % total;
      slides.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.tg-sh__carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Booking toggle — re-shows booking elements hidden by the salon's
 * booking_hidden flag once booking_hidden_until (unix seconds) has passed.
 */
(function () {
  var now = Math.floor(Date.now() / 1000);
  document.querySelectorAll('[data-tg-hide-until]').forEach(function (btn) {
    var until = parseInt(btn.getAttribute('data-tg-hide-until'), 10);
    if (until && now >= until) btn.removeAttribute('hidden');
  });
})();
